const { registerBlockType } = window.wp.blocks;

const { 
    RichText,
    InspectorControls,
    ColorPalette,
    MediaUpload,
    InnerBlocks
} = window.wp.editor;

const { 
     PanelBody, 
     IconButton, 
     RangeControl
} = window.wp.components;

 const ALLOWED_BLOCKS = ['core/button'];

 if ( window.wp.ajax ) {
    registerBlockType('custom-gutenberg/cta', {
        // built-in attributes
        title: 'Call to Action',
        description: 'Block to generate a custom Call to Action',
        icon: 'button',
        category: 'custom-components',
        example: {},
        
        // custom attributes
        attributes: {
            title: {
                type: 'string',
                source: 'html',
                selector: 'h2',
            },
            titleColor: {
                type: 'string',
                default: 'black'
            },
            body: {
                type: 'string',
                source: 'html',
                selector: 'p',
            },
            backgroundImage: {
                type: 'string',
                default: null
            },
            overlayColor: {
                type: 'string',
                default: 'black'
            },
            overlayOpacity: {
                type: 'number',
                default: '0.3'
            }
        },

        
        // built-in functions
        edit( { attributes, setAttributes } ) {

            const {
                title,
                titleColor,
                body,
                backgroundImage,
                overlayColor,
                overlayOpacity
            } = attributes;

            // custom functions
            function onChangeTitle(title) {
                setAttributes({ title: title });
            }
            function onChangeBody(body) {
                setAttributes({ body: body });
            }
            function onTitleColorChange(color) {
                setAttributes({ titleColor: color });
            }
            function onSelectImage(image) {
                setAttributes({ backgroundImage: image.sizes.full.url });
            }
            function onOverlayColorChange(overlayColor) {
                setAttributes({ overlayColor: overlayColor });
            }
            function onOverlayOpacityChange(overlayOpacity) {
                setAttributes({ overlayOpacity: overlayOpacity });
            }

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Color' }>
                        <p><strong>Select a color:</strong></p>
                        <ColorPalette value={ titleColor } onChange={ onTitleColorChange }></ColorPalette>
                    </PanelBody>
                    <PanelBody title={ 'Background Image Settings' }>
                        <p><strong>Select Background Image:</strong></p>
                        <MediaUpload 
                            onSelect={ onSelectImage }
                            type="image"
                            value={ backgroundImage } 
                            render={ ( { open } ) => (
                                <IconButton
                                    onClick={ open }
                                    icon="upload"
                                    classNames="editor-media-placeholder__button is-button is-default is-large">
                                    Background Image
                                </IconButton>
                            ) } />
                        <div style={{
                                marginTop: '20px',
                                marginBottom: '40px',
                            }}>
                            <p><strong>Overlay Color:</strong></p>
                            <ColorPalette value={ overlayColor } onChange={ onOverlayColorChange }></ColorPalette>
                        </div>
                        <RangeControl
                            label={ 'Overlay Opacity' }
                            value={ overlayOpacity }
                            onChange={ onOverlayOpacityChange }
                            min={ 0 } 
                            max={ 1 } 
                            step={ 0.01 } 
                            />
                    </PanelBody>
                </InspectorControls>,
                <div class="container position-relative cover-image" style={{
                    backgroundImage: `url(${backgroundImage})`,
                }}>
                    <div class="overlay" style={{ background: overlayColor, opacity: overlayOpacity }}></div>
                    <RichText 
                        key="editable" 
                        tagName="h2" 
                        placeholder="Title" 
                        value={ title }
                        onChange={ onChangeTitle }
                        style={ { color: titleColor } } />
                    <RichText 
                        key="editable" 
                        tagName="p" 
                        placeholder="Description" 
                        value={ body }
                        onChange={ onChangeBody } />
                    <InnerBlocks allowedBlocks={ ALLOWED_BLOCKS } />
                </div>
            ]);
        },

        save( { attributes } ) {

            const {
                title,
                titleColor,
                body,
                backgroundImage,
                overlayColor,
                overlayOpacity
            } = attributes;

            return (
                <div class="container position-relative cover-image" style={{
                    backgroundImage: `url(${backgroundImage})`,
                }}>
                    <div class="overlay" style={{ background: overlayColor, opacity: overlayOpacity }}></div>
                    <h2 style={ { color: titleColor } }>{ title }</h2>
                    <RichText.Content 
                        tagName="p" 
                        value={ body } />
                    <InnerBlocks.Content />
                </div>
            );
        },
    });
}